import {
  ACTION_LOAD_BALANCE_SUMMARY__REQUEST,
  ACTION_LOAD_BALANCE_SUMMARY__SUCCESS,
  ACTION_LOAD_BALANCE_SUMMARY__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_BALANCE_SUMMARY__REQUEST:
    case ACTION_LOAD_BALANCE_SUMMARY__SUCCESS:
      return null;

    case ACTION_LOAD_BALANCE_SUMMARY__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
